'use client'

import PropTypes from 'prop-types'
import MUIBox from '@mui/material/Box'
import MUILinearProgress from '@mui/material/LinearProgress'
import { useLoadingStore } from '@repo/store/useLoadingStore'

export const GlobalLoadingBar = ({ forceShow }) => {
  const isLoading = useLoadingStore((state) => state.isLoading)
  if (!isLoading && !forceShow) return null

  return (
    <MUIBox
      data-testid="GlobalLoadingBar"
      sx={{ width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 10, opacity: 0.3 }}
    >
      <MUILinearProgress title="GlobalLoadingBar" color="support" />
    </MUIBox>
  )
}

GlobalLoadingBar.propTypes = {
  forceShow: PropTypes.bool
}
